import React from 'react';

const MicrosoftOutlookLogo: React.FC<React.SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 1040.8409 742.6319"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <defs>
        <linearGradient id="linearGradient35">
          <stop offset="0" style={{ stopColor: '#4de2fb', stopOpacity: 1 }} />
          <stop offset="1" style={{ stopColor: '#28aee8', stopOpacity: 1 }} />
        </linearGradient>
        <linearGradient id="linearGradient5">
          <stop offset="0" style={{ stopColor: '#1582d8', stopOpacity: 1 }} />
          <stop offset="1" style={{ stopColor: '#0a64cc', stopOpacity: 1 }} />
        </linearGradient>
        <linearGradient
          id="linearGradient6"
          x1="749.08496"
          y1="212.54776"
          x2="738.25281"
          y2="843.01855"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-100)"
        >
          <stop offset="0" style={{ stopColor: '#1582d8', stopOpacity: 1 }} />
          <stop offset="1" style={{ stopColor: '#0a64cc', stopOpacity: 1 }} />
        </linearGradient>
        <linearGradient
          id="linearGradient36"
          x1="1773.6024"
          y1="939.29254"
          x2="2272.7681"
          y2="729.0332"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(982.3684)"
        >
          <stop offset="0" style={{ stopColor: '#4de2fb', stopOpacity: 1 }} />
          <stop offset="1" style={{ stopColor: '#28aee8', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <g transform="translate(-446.11368,-168.81981)">
        <g transform="matrix(0.7210846,0,0,0.7210846,-938.36876,150.65219)">
          <path
            style={{
              display: 'inline',
              opacity: 1,
              fill: '#158fda',
              fillOpacity: 1,
              stroke: 'none',
              strokeWidth: 13.8,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="m 2367.3337,1055.0767 h 732.6061 c 85.7128,0 155.1967,-69.48394 155.1967,-155.19671 V 374.94388 c 0,-45.60025 -22.8376,-87.46848 -62.4463,-110.06358 L 2809.398,46.917857 C 2758.4496,17.853896 2695.916,17.96081 2645.0673,47.198812 L 2210.7257,296.94524 v 601.52342 c 0,86.49223 70.1158,156.60804 156.608,156.60804 z"
          />
          <path
            style={{
              opacity: 1,
              fill: 'url(#linearGradient36)',
              stroke: 'none',
              strokeWidth: 13.8,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="m 2512.5126,955.90485 c 4.0919,-47.14548 33.902,-88.17006 77.478,-106.6248 0,0 396.8646,-222.88902 593.633,-338.22376 60.9006,-35.69659 71.5129,-108.06656 71.5129,-108.06656 V 898.2074 c 0,86.63652 -70.2328,156.8693 -156.8693,156.8693 h -475.7159 c -56.6639,0 -104.1681,-42.8129 -110.0387,-99.17185 z"
          />
          <g transform="translate(1651.4631)">
            <path
              d="M 1519.877,251.2168 837.52547,628.32813 973.5841,710.78516 c 50.4883,30.59807 123.685,47.15596 175.1597,18.24806 l 363.2363,-203.9922 c 48.6498,-27.32142 91.6933,-72.27526 91.6933,-150.09714 0,-79.04771 -54.5195,-105.13695 -83.7964,-123.72708 z"
              style={{
                display: 'inline',
                opacity: 1,
                fill: '#01459b',
                fillOpacity: 1,
                strokeWidth: 13.8,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
              }}
            />
            <path
              d="m 1079.793,26.322261 c -29.9013,-0.0714 -59.8212,7.48914 -86.73635,22.685551 L 416.91603,374.29883 635.43751,506.73242 1305.6445,128.9082 1166.4199,49.421871 c -26.8423,-15.32484 -56.7257,-23.02816 -86.6269,-23.09961 z"
              style={{
                opacity: 1,
                fill: '#26aee9',
                fillOpacity: 1,
                strokeWidth: 13.8,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
              }}
            />
            <path
              d="M 1305.6445,128.9082 635.4375,506.73242 854.61328,639.5625 1537.8821,262.45117 c -5.424,-4.0613 -12.0375,-7.82732 -18.0051,-11.23437 z"
              style={{
                opacity: 1,
                fill: '#0078d3',
                fillOpacity: 1,
                strokeWidth: 13.8,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
              }}
            />
          </g>
          <g transform="rotate(-0.9287484,1474.7334,-101601.24)">
            <path
              style={{
                display: 'inline',
                opacity: 1,
                fill: 'url(#linearGradient6)',
                stroke: 'none',
                strokeWidth: 13.8,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
              }}
              d="m 380.53529,208.22328 537.09931,8.64896 a 52.98464,52.98464 0 0 1 52.1209,54.03844 l -10.4693,522.88117 a 54.6032,54.6032 0 0 1 -55.4714,53.50306 l -531.12401,-8.55273 a 55.65563,55.65563 0 0 1 -54.74837,-56.76254 l 10.48154,-523.49416 a 51.2957,51.2957 0 0 1 52.11133,-50.2622 z"
            />
            <path
              fill="#ffffff"
              d="m 490.16342,435.72863 c 13.25707,-27.52059 34.65526,-50.55134 61.4478,-66.13255 29.67095,-16.55143 63.4538,-24.80264 97.62945,-23.84585 31.67488,-0.66941 62.93009,7.1541 90.35178,22.61579 25.78231,14.98096 46.54721,36.93136 59.77465,63.18764 14.40512,28.93194 21.58426,60.77252 20.95235,92.92329 0.69807,33.60039 -6.68849,66.89327 -21.56841,97.21171 -13.54236,27.19494 -34.96606,49.92756 -61.62353,65.38926 -6.0643,3.39337 -12.30713,6.42823 -18.69446,9.09614 -23.60846,9.861 -49.19125,14.70928 -75.03188,14.12058 -32.35158,0.76072 -64.29589,-7.15141 -92.34744,-22.87362 -26.00557,-15.00042 -47.03096,-36.97566 -60.56713,-63.30246 -14.49056,-28.51363 -21.75515,-59.99567 -21.18663,-91.80803 -0.60366,-33.31437 6.52861,-66.33062 20.86345,-96.5819 z m 65.49701,155.25283 c 7.06819,17.39811 19.05454,32.48715 34.56775,43.51674 15.80126,10.76035 34.72211,16.31173 53.99372,15.83973 20.52372,0.79094 40.75387,-4.94979 57.6329,-16.35472 15.31682,-10.99467 26.98825,-26.12467 33.56993,-43.51674 7.3576,-19.42313 10.98851,-39.99846 10.71081,-60.69999 0.2274,-20.89962 -3.18575,-41.68509 -10.09476,-61.47214 -6.10205,-17.86475 -17.39723,-33.61785 -32.51352,-45.3464 -16.4559,-11.94474 -36.63162,-18.00306 -57.13398,-17.15505 -19.68921,-0.49685 -39.03386,5.09818 -55.25548,15.98274 -15.77575,11.07592 -27.98953,26.29859 -35.21345,43.88804 -16.02521,40.31873 -16.10859,84.99973 -0.23498,125.37485 z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default MicrosoftOutlookLogo;
